import KeenSlider from 'keen-slider';
if (!customElements.get('ia-product-gallery')) {

  class IAProductGallery extends HTMLElement {
    constructor() {
      super();
      this.mainSlider = null;
      this.thumbSlider = null;
      this.currentSlideElement = null;
      this.prevButton = null;
      this.nextButton = null;
      this.bulletElements = null;
      this.mainSliderEl = this.querySelector('.ia-product-gallery__slider');
      this.thumbSliderEl = this.querySelector('.ia-product-gallery__thumbs');
      this.bulletsContainer = this.querySelector('.ia-product-gallery__bullets');
      this.autoplay = this.getAttribute('data-autoplay') === 'true';
      this.ThumbnailPlugin = window.iaTheme.ThumbnailPlugin;
      this.loop = this.dataset.loop === 'true';
    }
  
    connectedCallback() {
      this.initializeSlideshow();
    }
  
    disconnectedCallback() {
      if (this.mainSlider) {
        this.mainSlider.destroy();
      }
      if (this.thumbSlider) {
        this.thumbSlider.destroy();
      }
    }
  
    initializeSlideshow() {

      this.currentSlideElement = this.querySelector('.js-ia-slider-current');
      this.prevButton = this.querySelectorAll('.js-ia-slider-prev');
      this.nextButton = this.querySelectorAll('.js-ia-slider-next');
      this.bulletElements = this.querySelectorAll('.js-ia-slider-bullet');
  
      if (!this.mainSliderEl) {
        return;
      }

      this.mainSlider = new KeenSlider(this.mainSliderEl.querySelector('.keen-slider'), {
        loop: this.loop,
        breakpoints: {
          '(max-width: 1023px)': {
            slides: {
              perView: 1.2,
              spacing: 12,
              origin: 'center'
            },
          },
        },
        created: () => {
          this.classList.remove('is-loading');
        }
      });

      if (this.thumbSliderEl) {
        const isVertical = this.classList.contains('is-vertical');
        this.thumbSlider = new KeenSlider(
          this.thumbSliderEl.querySelector('.keen-slider'),
          {
            initial: 0,
            loop: this.loop,
            slides: {
              perView: this.thumbSliderEl.style.getPropertyValue('--items-desktop'),
              spacing: this.thumbSliderEl.style.getPropertyValue('--spacing-desktop').replace('px', ''),
            },
            breakpoints: {
              '(max-width: 1023px)': {
                slides: {
                  perView: this.thumbSliderEl.style.getPropertyValue('--items-mobile'),
                  spacing: this.thumbSliderEl.style.getPropertyValue('--spacing-mobile').replace('px', ''),
                },
              },
              '(min-width: 1024px)': {
                vertical: isVertical
              }
            },
            created: () => {
              this.updateActiveArrow(0);
            }
          },
          [this.ThumbnailPlugin(this.mainSlider)]
        );
      }

      this.mainSlider.on('slideChanged', () => {
        const currentIndex = this.mainSlider.track.details.rel;
        if (currentIndex >= 0 && this.currentSlideElement) {
          this.currentSlideElement.textContent = currentIndex + 1;
        }
        this.updateActiveBullet(currentIndex);
        this.updateActiveArrow(currentIndex);
      });

      if (this.prevButton) {
        this.prevButton.forEach(button => {
          button.addEventListener('click', () => {
          this.mainSlider.prev();
          });
        });
      }

      if (this.nextButton) {
        this.nextButton.forEach(button => {
          button.addEventListener('click', () => {
          this.mainSlider.next();
          });
        });
      }

      // Initialize bullet event listeners
      this.initializeBullets();
    }

    next() {
      if (this.mainSlider) {
        this.mainSlider.next();
      }
    }

    prev() {
      if (this.mainSlider) {
        this.mainSlider.prev();
      }
    }

    goToSlide(index) {
      if (this.mainSlider) {
        this.mainSlider.moveToIdx(index);
      }
    }

    initializeBullets() {
      if (!this.bulletElements || this.bulletElements.length === 0) {
        return;
      }

      this.bulletElements.forEach((bullet, index) => {
        bullet.addEventListener('click', () => {
          this.goToSlide(index);
        });
      });
    }

    updateActiveBullet(activeIndex) {
      this.bulletElements.forEach((bullet, index) => {
        if (index === activeIndex) {
          bullet.classList.add('is-active');
        } else {
          bullet.classList.remove('is-active');
        }
      });
    }

    updateActiveArrow(activeIndex) {
      this.prevButton.forEach(button => {
        if (activeIndex === 0) {
          button.classList.add('ia-hidden');
        } else {
          button.classList.remove('ia-hidden');
        }
      });
      if (!this.loop) {
        this.nextButton.forEach(button => {
          if (activeIndex === this.mainSlider.slides.length - 1) {
            button.classList.add('ia-hidden');
          } else {
            button.classList.remove('ia-hidden');
          }
        });
      }
    }

    destroy() {
      if (this.mainSlider) {
        this.mainSlider.destroy();
        this.mainSlider = null;
      }
      if (this.thumbSlider) {
        this.thumbSlider.destroy();
        this.thumbSlider = null;
      }
    }
  }


  window.iaTheme = window.iaTheme || {};
  window.iaTheme.ThumbnailPlugin = (main) => {
    return (slider) => {
      const removeActive = () => {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active")
        })
      }

      const addActive = (idx) => {
        slider.slides[idx].classList.add("active")
      }

      const addClickEvents = () => {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx)
          })
        })
      }

      slider.on("created", () => {
        addActive(slider.track.details.rel)
        addClickEvents()
        main.on("animationStarted", (main) => {
          removeActive()
          const next = main.animator.targetIdx || 0
          const relativeIndex = main.track.absToRel(next)
          addActive(relativeIndex)
          
          const thumbSliderDetails = slider.track.details
          const maxIdx = thumbSliderDetails.maxIdx
          const slidesPerView = thumbSliderDetails.slidesPerView || 1
          
          let targetIdx = relativeIndex - Math.floor(slidesPerView / 2)
          targetIdx = Math.max(0, Math.min(maxIdx, targetIdx))
          
          slider.moveToIdx(targetIdx)

        })
      })
    }
  }

  customElements.define('ia-product-gallery', IAProductGallery); 
}